import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SlotCounterStationDiscountSheet from '@/components/Counter/SlotCounterStationDiscountSheet';
import SlotCounterStationDiscountPromotion from '@/components/Counter/SlotCounterStationDiscountPromotion';
import SlotCounterStationPlatformPromotion from '@/components/Counter/SlotCounterStationPlatformPromotion';
import dateUtils from '@/utils/dateUtil';
import { mapGetters } from 'vuex';
export default {
  name: 'StationDiscount',
  components: {
    SlotCounterStationDiscountSheet: SlotCounterStationDiscountSheet,
    SlotCounterStationDiscountPromotion: SlotCounterStationDiscountPromotion,
    SlotCounterStationPlatformPromotion: SlotCounterStationPlatformPromotion
  },
  data: function data() {
    return {
      datePickerValue: dateUtils.todayTimestamp() * 1000 - 86400 * 1000,
      refIndex: 0,
      pickerOptionsLimit: {
        disabledDate: function disabledDate(pTime) {
          return pTime.getTime() < new Date() - 91 * 86400 * 1000 || pTime.getTime() > new Date() - 86400 * 1000;
        }
      }
    };
  },
  created: function created() {},
  computed: _objectSpread(_objectSpread({}, mapGetters('stations', ['asyncStations'])), mapGetters('user', ['userInfo'])),
  methods: {
    tabClick: function tabClick(el) {
      this.refIndex += 1;
    }
  }
};